import { Observable } from 'rxjs';
import {
  ApiService,
  APPROVE_MANY_APPLICATIONS_PATH,
  ApproveManyApplicationsBody,
  ApproveManyApplicationsPathParams,
  ApproveManyApplicationsResponse,
  REJECT_APPLICATIONS_PATH,
  RejectApplicationsBody,
  RejectApplicationsPathParams
} from '@core-http';

export class HostedGameApplicationsService extends ApiService {
  approveManyApplications(
    pathParams: ApproveManyApplicationsPathParams,
    payload: ApproveManyApplicationsBody
  ): Observable<ApproveManyApplicationsResponse> {
    const path: string = this.fillPathParams(APPROVE_MANY_APPLICATIONS_PATH, pathParams);

    return this.httpClient.post<ApproveManyApplicationsResponse>(`${this.env.apiUrl}${path}`, payload);
  }

  rejectApplications(pathParams: RejectApplicationsPathParams, payload: RejectApplicationsBody): Observable<void> {
    const path: string = this.fillPathParams(REJECT_APPLICATIONS_PATH, pathParams);

    return this.httpClient.post<void>(`${this.env.apiUrl}${path}`, payload);
  }
}
